import Emitter from "./Emitter";

export default class LogoutSuccess extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default() {
        this.emitParent({ wpgaction: "logoutSuccess.parent" });
        this.emitTop({ wpgaction: "logoutSuccess" });
        this.emitiOS({ wpgaction: "logoutSuccess" });
    }
}
